export enum AuditDatabase {
  CLIENT = 1,
  IDENTITY = 2,
  CLIENT_AND_IDENTITY = 3
}
